import React from "react";
import { useIntlTranslate } from "../../hooks";
import NativeSelect from "../select/NativeSelect";
import { isFixed } from "../../store/profiles/fixedProfiles";

export const ProfilesNativeSelect = ({
  id,
  profiles,
  selected,
  onChange,
  formatSelection,
  label,
  ariaLabelMessage,
}) => {
  const translate = useIntlTranslate();
  const translateProfile = (profileId) =>
    isFixed(profileId) ? translate(profileId) : profileId;

  return (
    <NativeSelect
      id={id}
      options={profiles}
      selected={selected}
      toggleView="input"
      onChange={onChange}
      formatSelection={(profileId, value) =>
        formatSelection
          ? formatSelection(profileId, value)
          : translateProfile(profileId)
      }
      formatOption={translateProfile}
      label={label}
      ariaLabelMessage={ariaLabelMessage}
    />
  );
};
